/**
 * Round a decimal to a certain number of decimal places
 * @param {number} val Number to be rounded
 * @param {number} fractionDigits Number of decimal places

 * @returns {number} Rounded Number
 */
const roundNumber = (val, fractionDigits = 0) => {
    if (fractionDigits < 0) throw new Error(`negative fraction: ${fractionDigits}`)

    const factor = Math.pow(10, fractionDigits)
    return val ? Math.round((val + Number.EPSILON) * factor) / factor : 0
}

export { roundNumber }
